module.exports = __webpack_public_path__ + "img/28ade6dc1ebf65cf872c41bbd92e7769.png";